import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import HomeCard from '../components/HomeCard';
import Header from "../components/Header";
import Footer from "../components/Footer";
import MastodonLogoSvg from '../resources/images/mastodon-logo.svg';
import PixelfedLogoSvg from '../resources/images/pixelfed-logo.svg';
import FediverseLogoSvg from '../resources/images/fediverse-logo.svg';
import Button from "react-bootstrap/Button";

export default class Home extends Component {

  constructor(props) {

    super(props);

    this.state = {}
  }

  render() {
    return (
      <div className="content">
        <Header />
        <div className="mt-5"/>
        <h1 className="text-center"><span className="logo-gradient logo-text">Find your friends!</span></h1>
        <div className="mt-3"/>
        <Container className="w-70">
          <p className="text-center fs-3">Find your friends from Mastodon in Pixelfed! <br/> Just login and we will do the magic hapens to find your friends in the Fediverse. </p>
        </Container>
        <div className="mt-4"/>
        <Container>
          <div className="row">
            <HomeCard color="step1 fs-5" title="1. Login with Mastodon" 
            image=<img src={MastodonLogoSvg} style={{ height: 72, width: 72 }} alt="Pixelfed icon" className="align-self-center grayscale-soft"/>
            description="Just to find your followings in the elephant platform">
            </HomeCard>
            <HomeCard color="step2 fs-5" title="2. Login with Pixelfed" 
            image=<img src={PixelfedLogoSvg} style={{ height: 72, width: 72 }} alt="Pixelfed icon" className="align-self-center grayscale-soft"/>
            description="To match followings with Mastodon and link your profiles">
            </HomeCard>
            <HomeCard color="step3 fs-5" title="3. Follow your friends!" 
            image=<img src={FediverseLogoSvg} style={{ height: 72, width: 72 }} alt="Pixelfed icon" className="align-self-center grayscale-soft"/>
            description="Check who is who in the Pixelfed platform and follow your friends!">
            </HomeCard>
          </div>
        </Container>
        <div className="mt-4"/>
        <Container>
          <Container className="text-center">
          <Button className="btn-xlg" size="lg" variant="primary" type="submit" onClick={this.start}>
            Get started
          </Button>
          </Container>
        </Container>
        <div className="mt-5"/>
        <div className="col-md-8 mx-auto text-center">
          <h4 className="fw-semibold text-muted">Fediverse social networks</h4>
          <p>We are working on supporting more Fediverse social networks where find your friends</p>
          <div className="d-flex flex-wrap justify-content-center gap-6 mt-4">
            <a className="text-decoration-none animate-img" href="https://joinmastodon.org/" target='_blank' rel="noreferrer">
              <img src={MastodonLogoSvg} style={{ height: 24, width: 24 }} alt="Pixelfed icon" className="grayscale" />
              <span className="text-muted"> Mastodon</span>
            </a>
            <a className="text-decoration-none animate-img" href="https://fediverse.party/" target='_blank' rel="noreferrer">
              <img src={FediverseLogoSvg} style={{ height: 24, width: 24 }} alt="Pixelfed icon" className="grayscale" />
              <span className="text-muted"> Fediverse</span>
            </a>
            <a className="text-decoration-none animate-img" href="https://pixelfed.org" target='_blank' rel="noreferrer">
              <img src={PixelfedLogoSvg} style={{ height: 24, width: 24 }} alt="Pixelfed icon" className="grayscale" />
              <span className="text-muted"> Pixelfed</span>
            </a>
          </div>
        </div>
        <div className="mt-5"/>
        <Footer />
      </div>
    );
  }

  start() {
    window.location.href = "/login"
  }

}
